import {
  Component,
  Input,
  ViewChild,
  OnDestroy,
  OnInit,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { Observable, Subject, Subscription, combineLatest, distinctUntilChanged, lastValueFrom, map, takeUntil } from 'rxjs';
import conflictOfInterest from 'src/app/data/constants/ConflictOfInterest.json';
import { Store } from '@ngrx/store';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import {
  MyPurchaseForm,
  WOCReason,
  DOTPReason,
  IItemToRequest,
  BudgetAllocationSummary
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import {
  deleteVendorsFromMyPurchase,
  updateDOTPToMyPurchase,
  updateIsRFSEnabled,
  updateVendorsToMyPurchase,
  updateWOCToMyPurchase,
  updateRFQDeadline,
  updatePDPCompliance,
} from 'src/app/core/store/form.actions';
import { Brand, Vendor } from 'src/app/shared/models/database-models';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import {
  DropDownOptions,
  ExtendedOEM,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models';
import { ExtendedWOCReason } from 'src/app/shared/models/app-models/ExtendedWOCReason.model';
import { ExtendedDOTPReason } from 'src/app/shared/models/app-models/ExtendedDOTPReason.model';
import { BackendApiService } from '../../../../core/services/backend-api';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { DOTP, WOC, selectDOTP, selectWOC } from '../../../../core/store/selector';
import { getProjectBudgetAllocations } from 'src/app/modules/shared/utils/derive-budget-allocations';
import { AclAslRecord } from './asl-vendor-search-dialog/dto/find-acl-asl-req.dto';
import { DeletedItemVendorsState } from 'src/app/core/store/DeletedItemVendors.reducer';
import { AlertType } from 'src/app/shared/components/alert/alert.component';
import { PureAbility } from '@casl/ability';
import { AbilityService } from '@casl/angular';
import { AbilityField, AppAbility } from 'src/app/core/services/permissions/AppAbility';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import _ from 'lodash';
import { getVendorContactPerson, getVendorEmailAddress } from 'src/app/modules/shared/utils/format-form-data-for-display';
import { MatDialog } from '@angular/material/dialog';
import { VendorSearchDialogComponent, VendorSearchDialogData } from './vendor-search-dialog/vendor-search-dialog.component';
import { AslVendorSearchDialogComponent, AslVendorSearchDialogData } from './asl-vendor-search-dialog/asl-vendor-search-dialog.component';
import { EditVendorDialogComponent, EditVendorDialogData } from './edit-vendor-dialog/edit-vendor-dialog.component';
import { DocumentMainStatus, DocumentSubStatus } from 'src/app/shared/models/database-models/DocumentStatus.model';
import { TagItemVendorService } from '../../rfs/tag-item-vendor.service';
import { environment } from 'src/environments/environment';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { CurrentWorkflowService } from 'src/app/modules/shared/current-workflow/current-workflow.service';

@Component({
  selector: 'app-add-vendor',
  templateUrl: './add-vendor.component.html',
  styleUrls: ['./add-vendor.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class AddVendorComponent implements OnChanges, OnDestroy {
  @ViewChild('vendorPg') vendorPg!: MatPaginator;
  @Input() isDocReadOnly: boolean = true;
  @Input() isLocked: boolean = true;
  isComponentReadOnly: boolean = true;
  @Input() recieved: any = '0.00';
  @Input() aclAslReq?: AclAslRecord[];
  form!: MyPurchaseForm;
  wocForm: FormGroup = new FormGroup<any>([]);
  dotpForm: FormGroup = new FormGroup<any>([]);
  isSOWStageError: boolean = false;
;
  // wocStore$: Observable<any>;
  dotpStore$: Observable<any>;
  WOCJustificationControl!: FormControl;
  DotpRemarksControl!: FormControl;
  Remarks!: FormControl;
  WOCFileReferenceNumberControl!: FormControl;
  rowSelection = new SelectionModel<Vendor>(true, []);
  isVRowSelected: boolean = false;
  isRFSEnabled: boolean | null = null;
  isRFSChangable: boolean = false;
  isCOTS: boolean = false;
  isReferenced: boolean = false;
  isRFQDeadlineEditable: boolean = false;
  isVendorEditable: boolean = false;
  fileReferences: any[] = [];
  warningMsg: string = '';
  advisoryMsgs: any[] = [];
  PDPItems: string | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();
  vendorDataSource = new MatTableDataSource<Vendor>([]);
  isRFSChangableLessThan6K:boolean = environment.isRFSChangableLessThan6K;

  vendorColumns = [
    {
      columnDef: 'Name',
      header: 'Vendor name',
      cell: (element: Vendor) => `${element.Name}`,
    },
    {
      columnDef: 'VendorContactPerson',
      header: 'Contact person',
      cell: (element: Vendor) =>
        getVendorContactPerson(element),
    },
    {
      columnDef: 'VendorNumber',
      header: 'Vendor no.',
      cell: (element: Vendor) => `${element.VendorNumber}`,
    },
    {
      columnDef: 'AddressCountryCode',
      header: 'Country',
      cell: (element: Vendor) => `${element.AddressCountryCode}`,
    },
    {
      columnDef: 'EmailAddress',
      header: 'Email',
      cell: (element: Vendor) =>
        getVendorEmailAddress(element),
    },
    {
      columnDef: 'VendorStatus',
      header: 'Vendor status',
      cell: (element: Vendor) =>
        `${element.VendorStatus == null || element.VendorStatus == undefined
          ? ''
          : element.VendorStatus
        }`,
    },
    {
      columnDef: 'VendorType',
      header: 'Vendor type',
      cell: (element: Vendor) =>
        `${element.IsPerm
          ? 'Permanent'
          : 'Temporary'
        }`,
    },
    {
      columnDef: 'rowActions',
      header: 'Action',
      cell: (element: Vendor) =>
        `${element.IsPerm
          ? 'Permanent'
          : 'Temporary'
        }`,
    }
  ];

  vendorDisplayedColumns = [
    'vSelect',
    ...this.vendorColumns.map((c) => c.columnDef),
  ];
  vendorForm!: Vendor[];
  rfqDeadline: number = 7;
  vendorActionType: string = '';
  pageSizeOptions = [5, 10, 20, 50];
  // to refactor
  haveUserAction: boolean = true;
  isOthersSelected: boolean = false;;
  itemList: IItemToRequest[] = [];
  wocReasons: WOCReason[] = [];
  deletedRfsVendors: Vendor[] = []
  selectedWoCReason!: WOCReason;
  selectedDoTPReason!: DOTPReason;
  selectedWocReferenceId!: string;
  containsOneVendor: boolean = false;
  elaborateWoCReason!: string;
  dotpReasons: DOTPReason[] = [];
  elaborateDoTPReason!: string;
  elaborateDoTPRemarks!: string;
  showWOCReason: boolean = false;
  purchaseType: string = '';
  vendorEdited!: Vendor;
  brandInformation: ExtendedOEM[] = [];
  isCE: boolean = false;
  loggedInUser: string | null = null;
  CE: string | null | undefined = null;
  updateFromStore = false;
  purchaseTypeMap: any = PurchaseTypeMap
  permissionData$: Observable<any>
  wocId: string | null = null
  dotpId: string | null = null
  tooltipInfo = `Enable this option to request Purchasing Department for sourcing `;//`Enable this option to receive assistance from the purchasing executive team to source vendors for your intended item purchase.`;
  tooltipInfoWOC: string = `Explain with justification why we choose to invite only the proposed company to quote. OpSec reason, strategic partner or designated sub-contractor is by itself not sufficient as a reason for WOC; and adequate details and context must be provided.`;
  tooltipInfoDOTP: string = `Explain why we accept the company’s quote (i.e. DOTP) e.g. company know they are the only one that can meet our requirements. For examples, for universities/IHLs, the choice of them as a collaborator is based purely on their ability and competency to collaborate, rather than a competitive selection process.`;
  isWOCInit = false;
  checkPDPComplianceInputs: any;
  canUpdateWoc: boolean = false
  canUpdateDotp: boolean = false
  amIaAssignedPe: boolean = false
  amIaRo: boolean = false
  private vendorDialogSubscription?: Subscription;
  isWocApproved: boolean = false;
  isVendorOnlyEditable = false;

  //#endregion
  constructor(
    private _fb: FormBuilder,
    private BackendApi: BackendApiService,
    private store: Store<{
      form: MyPurchaseForm;
      user: UserInformation;
      dp: StoreDropdowns;
      deletedItemVendors: DeletedItemVendorsState
    }>,
    private route: ActivatedRoute,
    private permissionsService: PermissionsService,
    private vendorDialog: MatDialog,
    private tagItemVendorService: TagItemVendorService,
    private currencyService: CurrencyService,
    private currentWorkFlowService: CurrentWorkflowService
  ) {

    this.warningMsg = conflictOfInterest?.conflictOfInterest[4]?.value;
    this.advisoryMsgs.push(...conflictOfInterest.conflictOfInterest);
    this.advisoryMsgs.pop();
    // this.wocStore$ = this.store
    //   .select(selectWOC)
    //   .pipe(
    //     distinctUntilChanged(
    //       (prev, cur) => JSON.stringify(prev) === JSON.stringify(cur)
    //     )
    //   );
    this.dotpStore$ = this.store
      .select(selectDOTP)
      .pipe(
        distinctUntilChanged(
          (prev, cur) => JSON.stringify(prev) === JSON.stringify(cur)
        )
      );
    this.permissionData$ = permissionsService.getService().pipe(takeUntil(this.destroy$))
    this.permissionData$.subscribe(data => {
      this.canUpdateWoc = data.ability.can('update', data.formWoc, AbilityField.WOC_DOTP)
      this.canUpdateDotp = data.ability.can('update', data.formWoc, AbilityField.WOC_DOTP)
      console.log('can update woc or dotp', this.canUpdateWoc, data.formWoc)
      this.enableOrDisableWocAndDotpForms()
    })
    this.wocForm = this._fb.group({
      WOCReason: '',
      FileReferenceNumber: '',
      WOCJustification: '',
    });
    this.dotpForm = this._fb.group({
      DOTPReason: '',
      DOTPRemarks: '',
      DOTPJustification: '',
    })
    this.WOCJustificationControl = this.wocForm.controls[
      'WOCJustification'
    ] as FormControl;
    this.DotpRemarksControl = this.dotpForm.controls[
      'DotpRemarksControl'
    ] as FormControl;
    this.WOCFileReferenceNumberControl = this.wocForm.controls[
      'FileReferenceNumber'
    ] as FormControl;
    // this.WOCReasonControl = this.wocForm.controls['WOCReason'] as FormControl;
    
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(
      ';'
    )[0] as string;
    
    this.store
    .select('user')
    .pipe(takeUntil(this.destroy$))
    .subscribe((user: UserInformation) => {
      this.loggedInUser = user.userName;
      this.isCE = !(this.CE === this.loggedInUser);
    });
    
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        this.form = form;
        this.CE = form.CE;
        this.isCE = !(this.CE === this.loggedInUser);

        this.vendorForm = form.VendorsToSource;
        this.itemList = form.ItemList;
        this.vendorDataSource = new MatTableDataSource<Vendor>(
          structuredClone(
            this.vendorForm.filter((vendor) => !vendor.isDeleted || (vendor.isDeleted && vendor.Strikethrough)).slice()
          ).concat(this.deletedRfsVendors)
        );
        this.containsOneVendor = this.checkIfDataContainsOneVendor(this.vendorDataSource.data);
        this.vendorDataSource.paginator = this.vendorPg;
        this.rfqDeadline = form.RFQDeadline;
        if (this.itemList.length > 0 && (this.purchaseType == 'rfq' || this.purchaseType === 'corporatecard')) {
          // this.checkForSourcing();
          this.checkForReferenceID();
        }
        // bryan - isRFSEnabled handler would only be configure in one function: checkForSourcing()
        // let totalPrice = 0;
        // for (let i = 0; i < this.itemList.length; i++) {
        //   if (!this.itemList[i].isDeleted) {
        //     totalPrice += ((this.itemList[i].ItemPrice.UnitPrice * this.itemList[i].ItemPrice.Quantity) / this.itemList[i].ItemPrice.UnitsPerQuantity) * this.itemList[i].ItemPrice.ExchangeRate;
        //   }
        // }
        // console.log('totalPrice', totalPrice);
        // if (form.isRFS && this.isCOTS){
        //   if(this.isRFSChangableLessThan6K === false && totalPrice < 6000){
        //     this.isRFSEnabled = false;
        //   }else{
        //     this.isRFSEnabled = form.isRFS;
        //   }
        // }
        this.checkPDPCompliance(form)

        if((this.wocForm.get("WOCReason")?.value != form.WoCReason?.id
          || this.wocForm.get("FileReferenceNumber")?.value != form.WOCFileReferenceNumber
          || this.wocForm.get("WOCJustification")?.value != form.WOCJustification
        )) {
          this.wocId = form.WOCId;
          this.wocForm.setValue({
            WOCReason: form.WoCReason?.id || '',
            FileReferenceNumber: form.WOCFileReferenceNumber || '',
            WOCJustification: form.WOCJustification || '',
          });
          this.selectedWoCReason = this.wocReasons.find((reason) => reason.id === form.WoCReason?.id)!;
          this.elaborateWoCReason = form.WOCJustification as string;
            if (form.WoCReason?.code) {
              this.getWOCFiles(form.WoCReason.code)
            }
        }
      });

    this.store
      .select('form')
      // only fire a observable change when one of the flags is different
      // flag depends on the properties we needed to check, it could be anything
      // that we want to run a process when that property changed
      // this should help to reduce unnecessary processes
      .pipe(distinctUntilChanged((prev, curr) => 
        // when document id changed
        prev.documentNo == curr.documentNo 
        // when document status changed
        && prev.documentStatusId == curr.documentStatusId
        // when workflow status changed
        && prev.documentSubStatusId == curr.documentSubStatusId
        // when isRFSEnabled flag changed
        && prev.isRFSEnabled == curr.isRFSEnabled
        // when something on the itemList changed
        && _.isEqual(prev.ItemList, curr.ItemList)
      ))
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        // to update local isRFSEnabled flag
        if (this.itemList.length > 0 && (this.purchaseType == 'rfq' || this.purchaseType === 'corporatecard') && !this.form.parentDocumentNo) {
          this.checkForSourcing();
        }
        
        this.amIaAssignedPe = !!form.ItemList.find(x => x.AddItems.PurchaseExecutive == this.loggedInUser);
        if (this.amIaAssignedPe) {
          // Is PE
          if (form.documentStatusId == 9 && form.documentSubStatusId == 25)
            this.isRFQDeadlineEditable = true;

          if ((form.isRFS || form.parentDocumentNo) && form.documentStatusId == 9 && form.documentSubStatusId == 25)
            this.isVendorOnlyEditable = true;

          this.isComponentReadOnly = !(
            (form.documentSubStatusId &&
              [DocumentSubStatus.Pending_Sourcing].includes(
                form.documentSubStatusId
              )) ||
            [DocumentMainStatus.Pending_PE_Sourcing].includes(
              form.documentStatusId
            )
          );
        } else if (this.form.generalForm.RO.id == this.loggedInUser) {
          // Is RO
          this.isComponentReadOnly = !(
            (form.documentSubStatusId &&
              [
                DocumentSubStatus.New,
                DocumentSubStatus.Draft,
                DocumentSubStatus.Aor_Draft,
                DocumentSubStatus.Woc_Draft,
                DocumentSubStatus.Woc_Dotp_Draft,
                DocumentSubStatus.D_Procurement_Draft,
                DocumentSubStatus.Sow_Draft,
                DocumentSubStatus.Vendor_Document_Draft,
                DocumentSubStatus.Rfs_Draft,
              ].includes(form.documentSubStatusId)) ||
            [DocumentMainStatus.New, DocumentMainStatus.Draft].includes(
              form.documentStatusId
            )
          );
          if (!form.isRFS && form.documentStatusId == 9 && form.documentSubStatusId == 25) {
            this.isVendorOnlyEditable = true;
          }
        }
      });

    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.wocReasons = dp.WOCReasons as ExtendedWOCReason[];
        this.dotpReasons = dp.DOTPReasons as ExtendedDOTPReason[];
        this.brandInformation = dp.OEM as ExtendedOEM[];

        // dp refreshed, attepmt to refresh selectedWoCReason
        if(this.form.WoCReason?.id && !this.selectedWoCReason) {
          this.selectedWoCReason = this.wocReasons.find((reason) => reason.id === this.form.WoCReason?.id)!;
        }
      });

    if (this.purchaseType === 'tender' || this.purchaseType === 'dc') {
      this.tableAddJustification();
    }
  }
  updateWOCReasonView() {
    let notDeletedVendors = this.vendorDataSource?.data?.filter(x => !x.isDeleted && !x.Strikethrough)
    return notDeletedVendors.length == 1 && this.recieved > 6000 && (!this.isRFSEnabled || this.isReferenced);
  }

  canShowDotpSection() {
    let notDeletedVendors = this.vendorDataSource?.data?.filter(x => !x.isDeleted && !x.Strikethrough)
    return notDeletedVendors?.length == 1 && this.recieved > 200000;
  }

  async checkPDPCompliance(form: MyPurchaseForm) {
    let genForm = form.generalForm
    let itemlist = form.ItemList

    const newCheckPDPComplianceInputs = { genForm, itemlist }
    if (this.checkPDPComplianceInputs && _.isEqual(this.checkPDPComplianceInputs, newCheckPDPComplianceInputs)) {
      // Skip check and unnecessary API calls if same inputs
      return
    }
    this.checkPDPComplianceInputs = newCheckPDPComplianceInputs

    if (!itemlist || itemlist.length === 0) {
      this.PDPItems = null;
      this.store.dispatch(updatePDPCompliance({ PDPComplianceItemNumbers: this.PDPItems }));
      return;
    }

    let allBudgetAllocationForms = itemlist.flatMap((item) =>
      item.BudgetAllocation.filter((budget) => !budget.isDeleted)
    );
    const budgetAllocations = await Promise.all(getProjectBudgetAllocations(allBudgetAllocationForms, itemlist, this.BackendApi, genForm))
    let pdpBudgetAllocations: BudgetAllocationSummary[] = []
    let itemNumbers: number[] = []
    let showPdpMessage = false;
    for (const budgetAlloc of budgetAllocations) {
      if (!budgetAlloc.Strikethrough) {
        const projectCodesRequirePDPCompliance = await lastValueFrom(this.BackendApi.getProjectCodesRequirePDPCompliance([budgetAlloc.projectCode]))
        const isRequirePDPCompliance = projectCodesRequirePDPCompliance[0].isRequirePDPCompliance;

        if (isRequirePDPCompliance) {
          budgetAlloc.id.split(',').forEach((x) => {
            let y: number = Number(x.trim())
            if (!itemNumbers.includes(y)) {
              const item = itemlist.find(item => item.AddItems?.displayItemNumber === y);
              if (item?.AddItems.MaterialSubGroupId?.HasVendor === true) {
                itemNumbers.push(y);
              }
            }
          })
          pdpBudgetAllocations.push(budgetAlloc)
        }
      }
    }
    if(itemNumbers.length > 0){
      showPdpMessage = true;
      //to show in sequential order
      itemNumbers = Array.from(new Set(itemNumbers)).sort((a, b) => a - b);
    }
    console.log(form.ItemList)
    this.PDPItems = showPdpMessage ? itemNumbers.join(', ') : null;
    this.store.dispatch(updatePDPCompliance({ PDPComplianceItemNumbers: this.PDPItems }))
  }

  public get alertType(): typeof AlertType {
    return AlertType;
  }
  get characterCount(): number {
    return this.elaborateWoCReason?.length ?? 0;
  }

  get dotpCharacterCount(): number {
    return this.elaborateDoTPReason?.length ?? 0;
  }
  get dotpRemarksCharacterCount(): number {
    return this.elaborateDoTPRemarks?.length ?? 0;
  }

  onChangeRFQDeadline(event: any) {
    this.store.dispatch(updateRFQDeadline({ RFQDeadline: event }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDocReadOnly']) {
      console.log('add-vendor-component is readonly changes', this.isDocReadOnly, this.canUpdateWoc)
      this.enableOrDisableWocAndDotpForms()
    }
    if (changes['recieved'] && this.recieved.length > 0) {
      this.recieved = changes['recieved'].currentValue.replace(/,/g, '')
      this.recieved = parseInt((this.recieved));
      // Bryan - commenting as this function isn't connected to receive 
      // and only for updating RFSEnabled to form
      // this.checkForRFSEnabled();
    }
  }
  enableOrDisableWocAndDotpForms() {
    console.log('enableOrDisableWocAndDotpForms', this.isDocReadOnly, this.canUpdateDotp)
    if (this.isDocReadOnly && !this.canUpdateWoc) {
      this.wocForm.disable()
    }
    if (this.isDocReadOnly && !this.canUpdateDotp) {
      console.log('enableOrDisableWocAndDotpForms')
      this.dotpForm.disable()
    }
    if (!this.isDocReadOnly || this.canUpdateWoc) {
      this.wocForm.enable()
    }
    if (!this.isDocReadOnly || this.canUpdateDotp) {
      this.dotpForm.enable()
    }
  }

  // no longer in use
  // checkForRFSEnabled() {
  //   this.store.dispatch(updateIsRFSEnabled({ isRFSEnabled: this.isRFSEnabled }));
  // }

  checkIfDataContainsOneVendor(vendors:Vendor[]):boolean{
    let strikeThrough : number = 0;
    for(let vendor of vendors ){
     if(vendor.Strikethrough) strikeThrough++;
    }
    return (vendors.length - strikeThrough) === 1;
  }

  ngOnInit(): void {
    // this.wocStore$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(async (woc: WOC) => {
    //     if (this.isWOCInit) {
    //       return
    //     }
    //     this.selectedWoCReason = woc.WoCReason as WOCReason;
    //     this.wocId = woc.WOCId;
    //     this.wocForm.setValue({
    //       WOCReason: woc.WoCReason?.id || '',
    //       FileReferenceNumber: woc.WOCFileReferenceNumber || '',
    //       WOCJustification: woc.WOCJustification || '',
    //     });
    //     this.elaborateWoCReason = woc.WOCJustification as string;
    //     if (woc.WoCReason?.code) {
    //       await this.getWOCFiles(woc.WoCReason.code)
    //     }
    //   });

    this.wocForm.valueChanges
      .pipe(distinctUntilChanged((prev, curr) => 
        prev.WOCReason == curr.WOCReason
        && prev.WOCJustification == curr.WOCJustification
        && prev.FileReferenceNumber == curr.FileReferenceNumber
      ))
      .subscribe((value: any) => {
      if (!this.isWOCInit) {
        this.isWOCInit = true;
        return;
      }
      // this.updateForm();
      
      // only attempt to update when even both property aren't null or aren't the same
      if (!(!value.WOCReason && !this.form.WoCReason?.id && !value.WOCJustification && !this.form.WOCJustification)) {
        if((value.WOCReason != this.form.WoCReason?.id)
          || value.FileReferenceNumber != this.form.WOCFileReferenceNumber 
          || value.WOCJustification != this.form.WOCJustification
        ) {
          this.selectedWoCReason = this.wocReasons.find((reason) => reason.id === value.WOCReason)!;
          this.updateForm();
        }
      }
    });

    this.dotpStore$
      .pipe(takeUntil(this.destroy$))
      .subscribe((dotp: DOTP) => {
        this.selectedDoTPReason = dotp.DoTPReason as DOTPReason;
        this.dotpId = dotp.DOTPId;
        let reason = this.dotpReasons.find(x => x.id === dotp?.DoTPReason?.id)
        this.isOthersSelected = !!reason?.code.toLowerCase().includes('other')
        this.dotpForm.setValue({
          DOTPReason: dotp.DoTPReason?.id || '',
          DOTPRemarks: dotp.DOTPRemarks || '',
          DOTPJustification: dotp.DOTPJustification || '',
        });
        this.elaborateDoTPReason = dotp.DOTPJustification as string;
        this.elaborateDoTPRemarks = dotp.DOTPRemarks as string;
        this.updateFromStore = true
      });

    this.dotpForm.valueChanges.subscribe((value: any) => {
      if (this.updateFromStore) {
        this.updateFromStore = false;
        return;
      }
      this.updateDOTPForm(value.DOTPReason);
    });
    this.currentWorkFlowService.wocApproval$.subscribe(
      (data) => {
        if (data) {
          this.isWocApproved = data;
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.vendorDialogSubscription) {
      this.vendorDialogSubscription.unsubscribe()
    }
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onToggleChange(event: any) {
    this.isRFSEnabled = event.checked;
    this.store.dispatch(updateIsRFSEnabled({ isRFSEnabled: event.checked }));
  }

  async checkForSourcing() {
    const filteredItemList = this.itemList.filter((item: any) => !item.isDeleted && !item.Strikethrough);
    this.isCOTS = filteredItemList.every(item => item.AddItems.isCOTS?.value === 'COTS');

    let totalPrice = 0;
    if (this.isCOTS) {
      const list = this.itemList.filter((item) => !item.isDeleted && !item.Strikethrough);

      for (const item of list) {
        let price = await this.currencyService.convertAsyncCurrencyToSGD(item.ItemPrice.UnitPrice, item.ItemPrice.Currency.value) ?? 0
        totalPrice += (price * item.ItemPrice.Quantity) / item.ItemPrice.UnitsPerQuantity;
      }
    }
    
    console.log('totalPrice', totalPrice);
    //enabling/disabling RFS
    if ( this.purchaseType == 'rfq' && this.form.generalForm?.reasonForNotUsingRFQ?.value !== environment.optForRFQReasonCode) {
      this.isRFSEnabled = false;
      this.isRFSChangable = false;
    } else if ((this.isCOTS && totalPrice > 6000) && ( (this.purchaseType === 'rfq' && this.form?.generalForm?.reasonForNotUsingRFQ?.value === environment.optForRFQReasonCode) || this.purchaseType === 'corporatecard')) {
      this.isRFSEnabled = true
      this.isRFSChangable = false;
    } else if (!this.isCOTS) {
      this.isRFSEnabled = false;
      this.isRFSChangable = false;
    } else {
      this.isRFSChangable = this.isRFSChangableLessThan6K;
      this.isRFSEnabled = this.isRFSChangableLessThan6K ? Boolean(this.form.isRFSEnabled) : false;
    }
    
    // update the form store when local isRFSEnabled is changed
    if(this.form.isRFSEnabled != this.isRFSEnabled) {
      this.store.dispatch(updateIsRFSEnabled({ isRFSEnabled: this.isRFSEnabled! }));
    }
  }

  checkForReferenceID() {
    this.isReferenced = this.itemList.some((item: any) => item.AddItems.ReferenceId);
  }

  removeVSelectedRows() {
    let newData = this.vendorForm.slice();
    this.rowSelection.selected.forEach((vendor) => {
      let index: number = this.vendorForm.findIndex(
        (d: Vendor) => d.VendorNumber == vendor.VendorNumber
      );
      if (vendor.MPVendorDetailsId) {
        newData[index] = {
          ...newData[index],
          Strikethrough: true,
          isDeleted:true
        };
      } else {
        newData[index] = {
          ...newData[index],
          isDeleted: true,
        };
      }
    });
    this.store.dispatch(deleteVendorsFromMyPurchase({ vendors: newData }));
    this.rowSelection = new SelectionModel<Vendor>(true, []);
    if (this.purchaseType === 'tender' && this.form.documentSubStatusId===DocumentSubStatus.Sow_Draft) this.checkForSowStage();
  }

  removeSelectedRow(vendor: Vendor) {
    // Check if vendor is associated with any RFS item-vendor tagging
    // If vendor is in tagging, prevent deletion until tagging conflict is manually resolved
    if (vendor.VendorNumber) {
      const {isSuccess} = this.tagItemVendorService.validateAllowVendorDelete(vendor.VendorNumber)
      if (!isSuccess) {
        return;
      }
    }
    let newData = null;
    if (vendor.MPVendorDetailsId) {
      newData = this.vendorForm.map(x => {
        return (x.VendorNumber == vendor.VendorNumber && !x.isDeleted && !x.Strikethrough) ? {
          ...x,
          Strikethrough: true,
          isDeleted:true
        } : x
      });
    } else {
      newData = this.vendorForm.map(x => {
        return (x.VendorNumber == vendor.VendorNumber && !x.isDeleted && !x.Strikethrough) ? {
          ...x,
          isDeleted: true
        } : x
      });
    }
    this.store.dispatch(deleteVendorsFromMyPurchase({ vendors: newData }));
    if (this.purchaseType === 'tender' && this.form.documentSubStatusId===DocumentSubStatus.Sow_Draft) this.checkForSowStage();
  }

  masterVToggle() {
    if (this.isAllVSelected()) {
      this.rowSelection.clear();
    } else {
      const filteredRow = this.vendorDataSource?.data?.filter(x => !x.isDeleted && !x.Strikethrough);
      filteredRow.forEach((row) =>
        this.rowSelection.select(row)
      );
    }
  }
  //vendors

  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.rowSelection.selected.length;
    const numRows = this.vendorDataSource?.data?.filter(x => !x.isDeleted && !x.Strikethrough).length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.rowSelection.selected.length !== 0) return true;
    return false;
  }
  // checkbox toggling
  onCheckboxChange($event: any, row: any): void {
    ($event) ? this.rowSelection.toggle(row) : null;
  }

  restrictNegativeNumberInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const enteredValue = parseFloat(inputElement.value);
    if (
      (!isNaN(enteredValue) && enteredValue < 7)
    ) {
      inputElement.value = "7"
      this.rfqDeadline = 7;
    }

    this.store.dispatch(updateRFQDeadline({ RFQDeadline: this.rfqDeadline }));

  }

  normalVendorOpen() {
    if (this.vendorDialogSubscription) {
      this.vendorDialogSubscription.unsubscribe()
    }

    const dialogData: VendorSearchDialogData = {
      vendorActionType: this.vendorActionType,
      routeParams: this.route.snapshot.params
    }

    const dialogRef = this.vendorDialog.open(VendorSearchDialogComponent, {
      width: `${window.innerWidth - 150}px`,
      minHeight: `${window.innerHeight - 50}px`,
      height: `${window.innerHeight - 50}px`,
      maxWidth: `1240px`,
      data: dialogData,
    });

    this.vendorDialogSubscription = dialogRef
    .afterClosed()
    .subscribe(() => {
      this.isSOWStageError = false;
    });

  }

  aslVendorOpen() {
    if (this.vendorDialogSubscription) {
      this.vendorDialogSubscription.unsubscribe()
    }

    const dialogData: AslVendorSearchDialogData = {
      showPdpMessage: this.PDPItems !== null
    }

    const dialogRef = this.vendorDialog.open(AslVendorSearchDialogComponent, {
      width: `${window.innerWidth - 150}px`,
      minHeight: `${window.innerHeight - 50}px`,
      height: `${window.innerHeight - 50}px`,
      maxWidth: `1240px`,
      data: dialogData,
    });

    this.vendorDialogSubscription = dialogRef
      .afterClosed()
      .subscribe(() => {
      });
  }

  editVendorOpen(row: Vendor) {
    if (this.vendorDialogSubscription) {
      this.vendorDialogSubscription.unsubscribe()
    }

    const dialogData: EditVendorDialogData = {
      VendorNumber: row.VendorNumber || '',
      vendorEdited: row,
      routeParams: this.route.snapshot.params
    }
    const dialogRef = this.vendorDialog.open(EditVendorDialogComponent, {
      width: `${window.innerWidth - 150}px`,
      minHeight: `${window.innerHeight - 50}px`,
      height: `${window.innerHeight - 50}px`,
      maxWidth: `1240px`,
      data: dialogData,
    });
    
    this.vendorDialogSubscription = dialogRef
    .afterClosed()
    .subscribe(() => {
    });
  }

  tableAddJustification() {
    this.vendorDisplayedColumns.splice(this.vendorDisplayedColumns.length - 1,
      0, 'Justification'
    )
    const vendorColumnDetails = {
      columnDef: 'Justification',
      header: 'Justification',
      cell: (element: Vendor) =>
        `${element.Justification == null || element.Justification == undefined
          ? ''
          : element.Justification
        }`,
    }
     this.vendorColumns.splice(this.vendorColumns.length - 1, 0, vendorColumnDetails)
  }

  updateForm() {
    const hasFile = this.hasFile();
    this.store.dispatch(
      updateWOCToMyPurchase({
        woc: {
          wocId: this.wocId,
          reason: { ...this.selectedWoCReason, hasFile },
          fileReferenceNumber:
            this.wocForm.get(['FileReferenceNumber'])?.value,
          justification: this.wocForm.get(['WOCJustification'])?.value || null,
        },
      })
    );
  }

  onTextChange(event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    this.dotpForm.get('DOTPJustification')?.setValue(value, { emitEvent: true });
  }

  updateDOTPForm(id: string) {
    const reason = this.dotpReasons.find(
      (i) => i.id === id
    ) as DOTPReason;
    this.store.dispatch(updateDOTPToMyPurchase({
      dotp: {
        dotpId: this.dotpId,
        reason,
        remarks: reason.code === 'Others' ? this.dotpForm.get('DOTPRemarks')?.value || null : null,
        justification: this.dotpForm.get(['DOTPJustification'])?.value || null
      }
    }))
  }

  async onSelectReason(event: MatSelectChange) {
    const id = event.value;
    if (id) {
      this.selectedWoCReason = this.wocReasons.find(
        (i) => i.id === id
      ) as WOCReason;
      await this.getWOCFiles(this.selectedWoCReason.code);
      if (!this.hasFile()) {
        this.WOCFileReferenceNumberControl.setValue("")
      }
      if (this.hasBlankApproval(this.selectedWoCReason)) {
        this.WOCJustificationControl.disable();
        this.WOCJustificationControl.setValue('');
        this.elaborateWoCReason = '';
      } else {
        this.WOCJustificationControl.enable();
      }
    }
  }

  async onSelectDOTPReason(event: MatSelectChange) {
    const id = event.value;
    this.isOthersSelected = false;
    let reason = this.dotpReasons.find(x => x.id === id)
    if (reason?.code.toLowerCase().includes('other')) { // assuming 'others' is the value for the "Others" option
      this.isOthersSelected = true;
    }

    if (id) {
      this.selectedDoTPReason = this.dotpReasons.find(
        (i) => i.id === id
      ) as DOTPReason;
      this.updateDOTPForm(id);
    }
  }



  async getWOCFiles(code: string) {
    if (code) {
      const wocFile = await lastValueFrom(this.BackendApi.getWocFile(code));
      this.fileReferences = wocFile || [];
    }
  }
  hasBlankApproval(reason: WOCReason) {
    return (
      reason && Object.hasOwn(reason, 'isWOCRequired') && !reason.isWOCRequired
    );
  }
  displayBlanketApprovalMessage(reason: WOCReason) {
    return (
      !this.displayWocNotRequiredForWorkflowMessage(reason) && reason && Object.hasOwn(reason, 'isBlanket') && reason.isBlanket == true
    );
  }

  displayWocNotRequiredForWorkflowMessage(reason: WOCReason) {
    return (
      reason && Object.hasOwn(reason, 'isWOCRequired') && reason.isWOCRequired == false
    );
  }

  hasFile() {
    console.log("valueee", this.fileReferences)
    return this.fileReferences.length > 0;
  }

  showTooltips(reason: WOCReason) {
    return this.selectedWoCReason?.id !== reason.id;
  }

  public get AbilityField(): typeof AbilityField {
    return AbilityField
  }

  checkForSowStage() {
    this.isSOWStageError = false;
    let notDeletedVendors = this.vendorDataSource?.data?.filter(x => !x.isDeleted && !x.Strikethrough)
    if (notDeletedVendors.length < 2) {
      this.isSOWStageError = true;
    }
  }
}
